import { Route } from "react-router-dom";
import { checkLoggedInAdmin } from "./routing_admin";

import ManagementLogin from "../pages/ManagementLogin";
import AdminHome from "../pages/AdminHome";
import Statistics from "../pages/Statistics";
import SuggestionList from "../pages/SuggestionList";
import GroupList from "../pages/GroupList";
import CategoryList from "../pages/CategoryList";
import AdminUserList from "../pages/AdminUserList";
import UserNotificationList from "../pages/UserNotificationList";
import NegativeWordList from "../pages/NegativeWordList";
import MemberGroupList from "../pages/MemberGroupList";
import PendingPostList from "../pages/PendingPostList";
import RejectedPostList from "../pages/RejectedPostList";
import PendingCommentList from "../pages/PendingCommentList";
import RejectedCommentList from "../pages/RejectedCommentList";
import SampleImageList from "../pages/SampleImageList";
import PaymentList from "../pages/PaymentList";
import EveryonePostList from "../pages/EveryonePostList";
import PostEventList from "../pages/PostEventList";
import NavigatorPostList from "../pages/NavigatorPostList";
import CreatePost from "../pages/CreatePost";
import CreateUserNotification from "../pages/CreateUserNotification";

const AdminHomePage = checkLoggedInAdmin(AdminHome);
const StatisticsPage = checkLoggedInAdmin(Statistics);
const AdminUserListPage = checkLoggedInAdmin(AdminUserList);
const UserNotificationListPage = checkLoggedInAdmin(UserNotificationList);
const MemberGroupListPage = checkLoggedInAdmin(MemberGroupList);
const GroupListPage = checkLoggedInAdmin(GroupList);
const CategoryListPage = checkLoggedInAdmin(CategoryList);
const NegativeWordListPage = checkLoggedInAdmin(NegativeWordList);
const PendingPostListPage = checkLoggedInAdmin(PendingPostList);
const RejectedPostListPage = checkLoggedInAdmin(RejectedPostList);
const PendingCommentListPage = checkLoggedInAdmin(PendingCommentList);
const RejectedCommentListPage = checkLoggedInAdmin(RejectedCommentList);
const SuggestionListPage = checkLoggedInAdmin(SuggestionList);
const SampleImageListPage = checkLoggedInAdmin(SampleImageList);
const PaymentListPage = checkLoggedInAdmin(PaymentList);
const EveryonePostListPage = checkLoggedInAdmin(EveryonePostList);
const PostEventListPage = checkLoggedInAdmin(PostEventList);
const NavigatorPostListPage = checkLoggedInAdmin(NavigatorPostList);
const CreatePostPage = checkLoggedInAdmin(CreatePost);
const CreateUserNotificationPage = checkLoggedInAdmin(CreateUserNotification);

export const ManagementRoutes = [
  <Route path="/login" key={1} element={<ManagementLogin />} />,
  <Route path="/adminhome" key={2} element={<AdminHomePage />} />,
  <Route path="/mng" key={3}>
    <Route path="dashboard">
      <Route path="statistics" element={<StatisticsPage />} />
    </Route>
    <Route path="management_users">
      <Route path="users" element={<AdminUserListPage />} />
    </Route>
    <Route path="public_users">
      <Route path="user_notifications" element={<UserNotificationListPage />} />
      <Route path="member_groups" element={<MemberGroupListPage />} />
    </Route>
    <Route path="data_definitions">
      <Route path="groups" element={<GroupListPage />} />
      <Route path="categories" element={<CategoryListPage />} />
      <Route path="sample_images" element={<SampleImageListPage />} />
    </Route>
    <Route path="negative_words">
      <Route path="negative_words" element={<NegativeWordListPage />} />
      <Route path="pending_posts" element={<PendingPostListPage />} />
      <Route path="rejected_posts" element={<RejectedPostListPage />} />
      <Route path="pending_comments" element={<PendingCommentListPage />} />
      <Route path="rejected_comments" element={<RejectedCommentListPage />} />
    </Route>
    <Route path="money">
      <Route path="payment" element={<PaymentListPage />} />
    </Route>
    <Route path="posts">
      <Route path="everyone_posts" element={<EveryonePostListPage />} />
      <Route path="post_events" element={<PostEventListPage />} />
    </Route>
    <Route path="navigator">
      <Route path="suggestions" element={<SuggestionListPage />} />
      <Route path="navigator_posts" element={<NavigatorPostListPage />} />
    </Route>
    <Route path="create_opinion_post" element={<CreatePostPage />} />
    <Route path="create_user_notification" element={<CreateUserNotificationPage />} />
  </Route>
];
